.root {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  padding-bottom: 20px;
  border-bottom: 1px solid var(--border);
}

.identity {
  display: flex;
  align-items: center;
  gap: 14px;
  min-width: 0;
}

.name {
  font-family: var(--font-display);
  font-size: clamp(1.7rem, 3.4vw, 2.4rem);
  font-weight: 800;
  letter-spacing: -0.01em;
  line-height: 1.1;
  color: var(--text);
  overflow-wrap: anywhere;
}

.identityText {
  min-width: 0;
}

.meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 4px;
  font-size: 0.92rem;
  color: var(--soft);
  /* Workout names come from the profile, so one long word must not overflow. */
  overflow-wrap: anywhere;
}

.handle {
  font-size: 0.92rem;
  color: var(--muted);
}

.sep {
  color: var(--border-md);
}

.range {
  font-size: 0.9rem;
  color: var(--muted);
  white-space: nowrap;
  padding-top: 6px;
}

/* Wraps onto its own row of .root so the long line never squeezes .range. */
.history {
  flex-basis: 100%;
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 2px 8px;
  font-size: 0.86rem;
  color: var(--muted);
}

.milestone {
  color: var(--soft);
}
